import React from 'react';
import s from './PaymentOption.module.scss';
import { ReactComponent as Checked } from 'images/new-icons/checked.svg';
import { ReactComponent as Unchecked } from 'images/new-icons/unchecked.svg';
import Button from 'components/shared/Button';
import useGetServiceByidS from 'sdk/hooks/salon/useGetServicesByIdS';
import { useTranslation } from 'react-i18next';

type PaymentMethodType = 'online' | 'offline';

type Option = {
  value: PaymentMethodType;
  title: string;
  subtitle: string;
};

type Service = {
  id: string;
  online_payment: boolean;
};

type Props = {
  paymentMethod: PaymentMethodType | null | any;
  setPaymentMethod: (method: PaymentMethodType | any) => void;
  handleNext: () => void;
  serviceId: string | string[];
  allowOnlinePayment?: boolean; // mock flag to disable online payment
  isLoading?: boolean;
};

const options: Option[] = [
  {
    value: 'online',
    title: 'Online',
    subtitle: 'credit card',
  },
  {
    value: 'offline',
    title: 'Offline (at venue/ home)',
    subtitle: 'credit card • cash',
  },
];

const PaymentOption: React.FC<Props> = ({
  paymentMethod,
  setPaymentMethod,
  handleNext,
  serviceId,
  allowOnlinePayment = true,
  isLoading = false,
}) => {
  const { t } = useTranslation() as any;
  const serviceIds = Array.isArray(serviceId) ? serviceId : [serviceId];
  const { data: services } = useGetServiceByidS(serviceIds);

  const isOnlinePaymentMethodAvailable =
    allowOnlinePayment && (services as Service[])?.every(service => service.online_payment);

  return (
    <div className={s.payment}>
      <div className={s.payment_title}>{t('Choose payment option')}</div>

      {options
        .filter(item => !(item.value === 'online' && !isOnlinePaymentMethodAvailable))
        .map(item => (
          <div
            key={item.value}
            className={s.payment_card}
            onClick={() => setPaymentMethod(item.value)}
          >
            <div className={s.payment_card_left}>
              <div className={s.payment_card_left_title}>{t(item.title)}</div>
              <div className={s.payment_card_left_subtitle}>{t(item.subtitle)}</div>
            </div>
            <div className={s.payment_card_right}>
              {paymentMethod === item.value ? <Checked /> : <Unchecked />}
            </div>
          </div>
        ))}

      <Button 
        wide 
        darkGreen 
        className={s.button} 
        onClick={handleNext}
        disabled={!paymentMethod || isLoading}
        loading={isLoading}
      >
        {t('Book now')}
      </Button>
    </div>
  );
};

export default PaymentOption;
